import { render, staticRenderFns } from "./SkyLanguage.vue?vue&type=template&id=2e086ec3&scoped=true&"
import script from "./SkyLanguage.vue?vue&type=script&lang=js&"
export * from "./SkyLanguage.vue?vue&type=script&lang=js&"
import style0 from "./SkyLanguage.vue?vue&type=style&index=0&id=2e086ec3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e086ec3",
  null
  
)

export default component.exports